import React from 'react';

import AddModelBooksToPackageButton from '@components/ActivePackages/AddModelBooksToPackageButton';

/** Aggiunge a un package i book della modella contrassegnati come fast package. */
const AddFastPackageButton = ({ modelID, noTooltip }) => (
    <AddModelBooksToPackageButton modelID={modelID} noTooltip={noTooltip} variant="fastPackage" />
);

export default AddFastPackageButton;
